/**
 * useCategoryNavigation Composable
 * Handles category navigation from URL hash (Single Responsibility Principle)
 * Compatible with Vue 2 and Vue 3
 */

/**
 * Composable for managing category navigation from URL
 * @param {Object} store - Vuex store instance
 * @returns {Object} Category navigation methods
 */
export function useCategoryNavigation(store) {
  if (!store) {
    console.warn("useCategoryNavigation: Store instance is required");
    return {
      handleCategoryFromUrl: () => {},
      setupHashChangeListener: () => {},
      removeHashChangeListener: () => {}
    };
  }

  /**
   * Extracts category ID from URL hash and sets it in store
   * Format: #cat_{categoryId}
   */
  function handleCategoryFromUrl() {
    const hash = window.location.hash;
    if (hash && hash.startsWith("#cat_")) {
      const categoryId = hash.substring(5); // Remove '#cat_'
      store.commit("SET_SELECTED_CATEGORY", categoryId);
    } else {
      // Clear selected category if not in URL
      store.commit("SET_SELECTED_CATEGORY", null);
    }
  }

  /**
   * Sets up hash change listener
   * @param {Function} handler - Handler function (usually handleCategoryFromUrl)
   */
  function setupHashChangeListener(handler) {
    window.addEventListener("hashchange", handler);
  }

  /**
   * Removes hash change listener
   * @param {Function} handler - Handler function to remove
   */
  function removeHashChangeListener(handler) {
    window.removeEventListener("hashchange", handler);
  }

  return {
    handleCategoryFromUrl,
    setupHashChangeListener,
    removeHashChangeListener
  };
}
